const useTouch = () => {
	if (typeof window === 'undefined') return false;

	return 'ontouchstart' in global || navigator.maxTouchPoints > 0;
};

export default useTouch;
